export const urls = {
    disable: id => `/api/items/${id}/disable`
};

export const initialState = {
    openRemoveAfterMarkAsSold: false,
    items: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REMOVE_MARK_AS_SOLD_MYAD':
            return {
                ...state,
                openRemoveAfterMarkAsSold: action.data
            };
        case 'RECEIVE_MYADS': {
            const myAdsItems = state.items || {};
            const items = { ...myAdsItems, [action.currentPage]: action.data.data };

            return {
                ...state,
                items
            };
        }
        default:
            return state;
    }
};
